import {createFileRoute, useParams} from '@tanstack/react-router';
import React from "react";
import ClubBookingsPage from "../../../../bookings/organiser/ClubBookingsPage.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/bookings')({
    component: RouteComponent,
});

function RouteComponent() {
    const params = useParams({strict: false});

    return <ClubBookingsPage clubUid={params.club_uid} />;
}
